import axios from "axios";
import { cdnHistoricalTransimissionValidator, headers } from "../../app/conf";
import { makeQuery } from "../../shared/helpers/commons";

export const getTransmissionHistoryLogs = (imei, filters, token) => {
    // Agregar el token a los filtros como query parameter
    const filtersWithToken = {
        ...filters,
        token: token
    };

    return axios({
        method: "get",
        url: `${cdnHistoricalTransimissionValidator}/api/logs/${imei}?${makeQuery(filtersWithToken)}&source=web`,
        headers: headers
    });
};
